<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const TickIcon = getIcon("TickIcon");
export let className = "";
</script>

{#if typeof TickIcon === 'string'}
	<img src={TickIcon} alt={$t(Verbiage.icon_alt, 'alts')} class={className} />
{:else if typeof TickIcon === 'function'}
	<svelte:component this={TickIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
